export default function getPercentualOfTotal(
    value: number,
    total: number,
): string {
    const percentual = (value / total) * 100;
    return percentual.toFixed(1) + "%";
}